import type { InventoryOutlookReport } from "@/lib/manufacturing/inventoryMatchClient";

export async function renderInventoryOutlookPdfToBlob(
  report: InventoryOutlookReport,
  generatedOn: string,
): Promise<{ ok: true; blob: Blob } | { ok: false; error: string }> {
  try {
    const [{ pdf }, { InventoryOutlookPdf }] = await Promise.all([
      import("@react-pdf/renderer"),
      import("./InventoryOutlookPdf"),
    ]);
    const blob = await pdf(InventoryOutlookPdf({ report, generatedOn })).toBlob();
    return { ok: true, blob };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : "Could not build the outlook PDF." };
  }
}
